import React from "react";
import { Image, ImageProps } from "antd";

interface IProps extends ImageProps {}

export default function ImageUI(props: IProps) {
  return <Image {...props} />;
}
